import {BaseContainerModel} from '../base-container.model';
import {bl_asv_consultation_hdr_RowClass} from '../../dbschema';

export class AsvConsultationHdrModel extends BaseContainerModel {
    bl_asv_consultation_hdr: bl_asv_consultation_hdr_RowClass = new bl_asv_consultation_hdr_RowClass();
}
